/**
 * @module Widget
 */

import { Component, Input } from '@angular/core';
import { WidgetLayersClass } from '@class/widgetLayers.class';
import { UID } from '@models/uid.model';
import { ItemColor } from '@functions/item.functions';

@Component({
  selector: 'app-widget-layers-fully-colored',
  templateUrl: './widget-layers-fully-colored.component.html',
  styleUrls: ['./widget-layers-fully-colored.component.css']
})
export class WidgetLayersFullyColoredComponent  {

  @Input() widgetLayers: WidgetLayersClass;
  @Input() current: UID;

  color = ItemColor('widgets');

  constructor() {}

  receiveValue(fullyColored: boolean) {
    this.widgetLayers.layer(this.current).change({ stickerFullyColored: fullyColored });
    if(this.widgetLayers.uid.value === this.current) this.widgetLayers.duplicateLayersOptions({ stickerFullyColored: fullyColored }, this.current);
  }

}